package com.zaurh.portfolio

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.tooling.preview.Preview
import com.zaurh.portfolio.di.initKoin
import com.zaurh.portfolio.main.MainScreen
import com.zaurh.portfolio.main.MainViewModel
import com.zaurh.portfolio.ui.theme.PortfolioTheme
import org.koin.compose.viewmodel.koinViewModel

@Composable
@Preview
fun App(
    viewModel: MainViewModel = koinViewModel()
) {
    val darkMode = viewModel.darkModeEnabled.collectAsState()

    PortfolioTheme(darkMode.value) {
        MainScreen(viewModel)
    }
}